import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { UbsBlogStoreService } from '../../services/ubs-blog-store.service';
import { UbsBlogService } from '../../services/ubs-blog.service';
import { Blog } from '../../services/ubs-blog-model';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ubs-blog-summary',
  templateUrl: './ubs-blog-summary.component.html',
  styleUrls: ['./ubs-blog-summary.component.scss']
})
export class UbsBlogSummaryComponent implements OnChanges,OnDestroy{
  @Input() blogContentId:string;
  vm$ = this.store.vm$;
  blog:Blog;
  numberOfArticles:number;
  lastestArticle:string;
  private destroy$ = new Subject<void>();
  
  constructor(
    private store:UbsBlogStoreService,
    private ubsBlogService:UbsBlogService,){}
  

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["blogContentId"]){
      console.log(this.blogContentId)
/*       this.store.blogs$.subscribe((blogs:Blog[]) => {
        
      }) */
      //console.log(this.blog);
      /* this.numberOfArticles = this.blog.blogEntries.length;
      if(this.numberOfArticles > 0){
        this.lastestArticle = this.blog.blogEntries[0].contentName;
      } */
      setTimeout(() => {
        this.store.blogs$.pipe(takeUntil(this.destroy$)).subscribe(blogs => {
          console.log(blogs);
          this.blog = blogs.find(blog => blog.blogContentId == this.blogContentId);
          console.log(this.blog);
          if(this.blog != undefined){
            this.numberOfArticles = this.blog.blogEntries.length;
            console.log(this.numberOfArticles);
            if(this.numberOfArticles > 0){
              this.lastestArticle = this.blog.blogEntries[0].contentName;
            }
          }
          
        })
      }, 600);
      
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next;
    this.destroy$.complete;
  }


}
